import { useState } from 'react'
import { Game } from '../srm/srm-parser'

interface AreaConfig {
  key: keyof Game['collectionItems']
  label: string
  arrayFields: [string, string][]
  boolField?: string
}

const AREA_CONFIGS: AreaConfig[] = [
  {
    key: 'crateria',
    label: 'Crateria',
    arrayFields: [
      ['missilePacks', 'Missile Packs'],
      ['superMissilePacks', 'Super Missile Packs'],
      ['powerBombPacks', 'Power Bomb Packs'],
      ['energyTanks', 'Energy Tanks']
    ]
  },
  {
    key: 'brinstar',
    label: 'Brinstar',
    arrayFields: [
      ['missilePacks', 'Missile Packs'],
      ['superMissilePacks', 'Super Missile Packs'],
      ['powerBombPacks', 'Power Bomb Packs'],
      ['energyTanks', 'Energy Tanks']
    ],
    boolField: 'reserveTank'
  },
  {
    key: 'norfair',
    label: 'Norfair',
    arrayFields: [
      ['missilePacks', 'Missile Packs'],
      ['superMissilePacks', 'Super Missile Packs'],
      ['powerBombPacks', 'Power Bomb Packs'],
      ['energyTanks', 'Energy Tanks']
    ],
    boolField: 'reserveTank'
  },
  {
    key: 'wreckedShip',
    label: 'Wrecked Ship',
    arrayFields: [
      ['missilePacks', 'Missile Packs'],
      ['superMissilePacks', 'Super Missile Packs'],
      ['energyTanks', 'Energy Tanks']
    ],
    boolField: 'reserveTank'
  },
  {
    key: 'maridia',
    label: 'Maridia',
    arrayFields: [
      ['missilePacks', 'Missile Packs'],
      ['superMissilePacks', 'Super Missile Packs'],
      ['powerBombPacks', 'Power Bomb Packs'],
      ['energyTanks', 'Energy Tanks']
    ],
    boolField: 'reserveTank'
  }
]

function CollapsibleArea({
  label,
  children
}: {
  label: string
  children: React.ReactNode
}) {
  const [open, setOpen] = useState(false)
  return (
    <div className="collapsible">
      <button
        className={`collapsible-header${open ? ' collapsible-header--open' : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="collapsible-chevron" />
        {label}
      </button>
      {open && <div className="collapsible-body">{children}</div>}
    </div>
  )
}

function CollectionSection({
  collectionItems,
  onUpdateArray,
  onUpdateBool
}: {
  collectionItems: Game['collectionItems']
  onUpdateArray: (
    area: keyof Game['collectionItems'],
    field: string,
    index: number,
    value: boolean
  ) => void
  onUpdateBool: (
    area: keyof Game['collectionItems'],
    field: string,
    value: boolean
  ) => void
}) {
  return (
    <div className="card-section">
      <h3 className="section-title">Collection Items</h3>
      <div className="collection-areas">
        {AREA_CONFIGS.map(({ key, label, arrayFields, boolField }) => {
          const areaData = collectionItems[key] as any
          return (
            <CollapsibleArea key={key} label={label}>
              {arrayFields.map(([fieldKey, fieldLabel]) => {
                const values: boolean[] = areaData[fieldKey]
                if (!values || values.length === 0) return null
                return (
                  <div key={fieldKey} className="pack-row">
                    <span className="pack-row-label">{fieldLabel}</span>
                    <div className="pack-checks">
                      {values.map((checked, i) => (
                        <label key={i} className="pack-check">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) =>
                              onUpdateArray(key, fieldKey, i, e.target.checked)
                            }
                          />
                          <span>{i + 1}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )
              })}
              {boolField && (
                <div className="pack-row">
                  <label className="check-label">
                    <input
                      type="checkbox"
                      checked={areaData[boolField]}
                      onChange={(e) => onUpdateBool(key, boolField, e.target.checked)}
                    />
                    <span>Reserve Tank</span>
                  </label>
                </div>
              )}
            </CollapsibleArea>
          )
        })}
      </div>
    </div>
  )
}

export default CollectionSection
